import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ContactQueryNames } from '../queries/useContacts.queries';

export const useUnassignAllAccountManagerRolesQuery = (
  contactId?: string,
  onSuccess?: () => void,
  onError?: (errorText?: string) => void
) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    () => api.put(API_URL.CONTACTS_UNASSIGN_ACCOUNT_MANAGER_BY_CONTACT_ID(contactId || '')),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [ContactQueryNames.CONTACT_LIST],
        });
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (response) => {
        const responseErrorMessage = _.get(response, 'response.data.elevate_error_message', '');
        if (responseErrorMessage && onError) {
          onError(responseErrorMessage);
        }
      },
    }
  );

  return {
    mutateAsync,
    isLoading,
  };
};
